export default __webpack_public_path__ + "static/media/item_3@2x.4cda149b.webp";